export const TRISOMY_21 = {
  id: 'trisomy_21',
  label: 'Trisomia 21',
};

export const OTHER_NUMERICAL_ABNORMALITY = {
  id: 'other_numerical_abnormality',
  label: 'Altra anomalia numerica',
};

export const STRUCTURAL_CHROMOSOMAL_ABNORMALITY = {
  id: 'structural_chromosomal_abnormality',
  label: 'Anomalia strutturale cromosomica',
};

export const CYSTIC_FIBROSIS = {
  id: 'cystic_fibrosis',
  label: 'Fibrosi cistica',
};

export const THALASSEMIA = {
  id: 'thalassemia',
  label: 'Talassemia',
};

export const NEUROMUSCULAR_DISORDERS = {
  id: 'neuromuscular_disorders',
  label: 'Disordini neuromuscolari',
};

export const METABOLIC_DISORDERS = {
  id: 'metabolic_disorders',
  label: 'Disordini metabolici',
};

export const FRAGILE_X_SYNDROME = {
  id: 'fragile_x_syndrome',
  label: 'Sindrome X fragile',
};

export const CARDIAC_MALFORMATIONS = {
  id: 'cardiac_malformations',
  label: 'Malformazioni cardiache',
};

export const SKELETAL_MALFORMATIONS = {
  id: 'skeletal_malformations',
  label: 'Malformazioni scheletriche',
};

export const ABDOMINAL_MALFORMATIONS = {
  id: 'abdominal_malformations',
  label: 'Malformazioni addominali',
};

export const BRAIN_MALFORMATIONS = {
  id: 'brain_malformations',
  label: 'Malformazioni cerebrali',
};

export const MULTIPLE_MALFORMATIONS = {
  id: 'multiple_malformations',
  label: 'Malformazioni multiple',
};

export const CLEFT_LIP_PALATE = {
  id: 'cleft_lip_palate',
  label: 'Labbro leporino e palatoschisi',
};

export const SPINA_BIFIDA = {
  id: 'spina_bifida',
  label: 'Spina bifida',
};

export const CMV = {
  id: 'cmv',
  label: 'CMV',
};

export const TOXOPLASMOSIS = {
  id: 'toxoplasmosis',
  label: 'Toxoplasmosi',
};

export const OTHER = {
  id: 'other',
  label: 'Altro',
};
